export function detectMimeType(b64) {
    var signatures = {
        JVBERi0: "application/pdf",
        R0lGODdh: "image/gif",
        R0lGODlh: "image/gif",
        iVBORw0KGgo: "image/png",
        "/9j/": "image/jpg",
    };
    for (var s in signatures) {
        if (b64.indexOf(s) === 0) {
            return signatures[s];
        }
    }
}
export function getImageString(b64) {
    if (b64)
        return "data:" + detectMimeType(b64) + ";base64," + b64;
    else
        return "";
}
export function base64toExcel(respData, fileName) {
    var decodedPdfContent = window.atob(respData);
    var byteArray = new Uint8Array(decodedPdfContent.length);
    for (var i = 0; i < decodedPdfContent.length; i++) {
        byteArray[i] = decodedPdfContent.charCodeAt(i);
    }
    var blob = new Blob([byteArray.buffer], { type: "application/vnd.ms-excel" });
    var _pdfurl = URL.createObjectURL(blob);
    var link = document.createElement("a");
    document.body.appendChild(link);
    link.href = _pdfurl;
    link.download = fileName;
    var evt = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
    });
    link.dispatchEvent(evt);
    window.URL.revokeObjectURL(_pdfurl);
    link.remove();
}
export function base64toZip(respData, fileName) {
    var decodedPdfContentzip = window.atob(respData);
    var byteArrayzip = new Uint8Array(decodedPdfContentzip.length);
    for (var i = 0; i < decodedPdfContentzip.length; i++) {
        byteArrayzip[i] = decodedPdfContentzip.charCodeAt(i);
    }
    var blobzip = new Blob([byteArrayzip.buffer], { type: "application/zip" });
    var _pdfurlzip = URL.createObjectURL(blobzip);
    var linkzip = document.createElement("a");
    document.body.appendChild(linkzip);
    linkzip.href = _pdfurlzip;
    linkzip.download = fileName;
    var evtzip = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
    });
    linkzip.dispatchEvent(evtzip);
    window.URL.revokeObjectURL(_pdfurlzip);
    linkzip.remove();
}
export function base64toPDF(respData, fileName) {
    var decodedPdfContents = window.atob(respData);
    var byteArrays = new Uint8Array(decodedPdfContents.length);
    for (var i = 0; i < decodedPdfContents.length; i++) {
        byteArrays[i] = decodedPdfContents.charCodeAt(i);
    }
    var blobs = new Blob([byteArrays.buffer], { type: "application/pdf" });
    var _pdfurls = URL.createObjectURL(blobs);
    var links = document.createElement("a");
    document.body.appendChild(links);
    links.href = _pdfurls;
    links.download = fileName;
    var evts = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
    });
    links.dispatchEvent(evts);
    window.URL.revokeObjectURL(_pdfurls);
    links.remove();
}
export var openBase64PDFInNewTab = function (base64Data, fileName) {
    var sliceSize = 1024;
    var byteCharacters = window.atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);
    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);
        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset)
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    var blob = new Blob(byteArrays, { type: "application/pdf" });
    var nav = window.navigator;
    if (nav && nav.msSaveOrOpenBlob)
        nav.msSaveOrOpenBlov(blob, "".concat(fileName, ".pdf"));
    else
        window.open(URL.createObjectURL(blob));
};
export var getImageBase64String = function (file) {
    return new Promise(function (resolve, reject) {
        var fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = function () {
            resolve(fileReader.result);
        };
        fileReader.onerror = function (error) {
            reject(error);
        };
    });
};
export var downloadBase64Image = function (b64String, fileName) {
    if (b64String) {
        var downloadLink = document.createElement("a");
        downloadLink.href = b64String;
        downloadLink.download = fileName;
        downloadLink.click();
    }
};
export var getImageFileExtension = function (base64String) {
    switch (base64String) {
        case "image/gif":
            return ".gif";
        case "image/png":
            return ".png";
        case "image/jpg":
            return ".jpg";
    }
};
